// extracted by mini-css-extract-plugin
module.exports = {"history":"history-screen_history__lWsH6","history__title":"history-screen_history__title__2agsE","history__sample":"history-screen_history__sample__awrIR"};